export enum UnPaidOrderPermissions {
  UNPAID_ORDER_WRITE = 'ORDER_UNPAIDWRITE',
  UNPAID_ORDER_VIEW = 'ORDER_UNPAIDVIEW',
}
